export enum PastTimePeriodEnum {
  LAST_WEEK = "Last Week",
  LAST_MONTH = "Last Month",
  LAST_3_MONTHS = "Last 3 Months",
  LAST_6_MONTHS = "Last 6 Months",
  LAST_YEAR = "Last Year",
  SHOW_ALL = "Show All"
}
